// extracted by css-extract-rspack-plugin
export default {"IncludeTargetIcon":"IncludeExcludeTarget-module__IncludeTargetIcon__FBsaC","ExcludeTargetIcon":"IncludeExcludeTarget-module__ExcludeTargetIcon__jDzUR"};